import angular from 'angular';
import onboardingAddedParty from './onboardingAddedParty';

export default angular
  .module('components.onboardingAddedParty', [])
  .component('onboardingAddedParty', onboardingAddedParty).name;
